import React from 'react';
import { ProductCarousel, ProductTileWithSwatches, Card } from '@lululemon/b2b-ecom-pattern-library';
import classnames from 'classnames';
import { toColorSwatchesAndImages } from 'helpers/mappers/toColorSwatchesAndImages';
import { randomMockPrice } from 'helpers/mocks/mockData';
import styles from './product-carousel.module.scss';
import { Data } from './types';
import { FEATURE_FLAG_LIST, useFeatureFlags } from 'hooks';

const ProductPromotionCarousel: React.FC<Data> = ({ data }) => {
  const { isFeatureEnabled } = useFeatureFlags();
  const isColorSwatchEnabled = isFeatureEnabled(FEATURE_FLAG_LIST.COLOR_SWATCH);

  const productList = data?.data?.dataSource?.items;
  const DEFAULT_TILES_PER_PAGE = 4;
  const {
    title,
    tilesPerPage,
    promotionTitle,
    promotionDescription,
    promotionImage,
    promotionTargetText,
    promotionTarget,
    callToAction,
    webRoute,
    showProductCard,
  } = data;
  type TilesPerPage = 1 | 2 | 3 | 4;
  const tilePerPage: TilesPerPage =
    tilesPerPage > DEFAULT_TILES_PER_PAGE ? DEFAULT_TILES_PER_PAGE : (tilesPerPage as TilesPerPage);

  if (productList.length < 1) return null;

  return (
    <div data-testid="product-promotion-carousel_test-id" className={classnames(styles.carousel, 'lll-grid-padding')}>
      {showProductCard ? (
        <ProductCarousel slidesPerPage={tilePerPage} title={title} callToAction={callToAction} webRoute={webRoute}>
          <>
            {productList.map((product, index) => (
              <ProductTileWithSwatches
                key={index}
                showColorsOnHover={false}
                colors={toColorSwatchesAndImages(product, isColorSwatchEnabled)}
                href={product?._url as string}
                name={product?.name as string}
                priceProps={randomMockPrice(product?.variants)}
              />
            ))}
            <Card
              classes={{ container: styles.carousel__card }}
              ctaText={promotionTargetText}
              ctaURL={promotionTarget}
              heading={promotionTitle}
              imageProps={
                promotionImage
                  ? {
                      src: promotionImage,
                    }
                  : undefined
              }
              subContent={promotionDescription}
            />
          </>
        </ProductCarousel>
      ) : (
        <ProductCarousel slidesPerPage={tilePerPage} title={title} callToAction={callToAction} webRoute={webRoute}>
          {productList.map((product, index) => (
            <ProductTileWithSwatches
              key={index}
              showColorsOnHover={false}
              colors={toColorSwatchesAndImages(product, isColorSwatchEnabled)}
              href={product?._url as string}
              name={product?.name as string}
              priceProps={randomMockPrice(product?.variants)}
            />
          ))}
        </ProductCarousel>
      )}
    </div>
  );
};

export default ProductPromotionCarousel;
